import { creatureAppearanceDocument, creatureBodyAppearanceDocument } from '../authoring/creature-appearance';
import type { ItemFieldRow } from './item-field-reader';
import type { FromBaseRow } from './from-base-context';
import { constructEncounterCreatureSourceFromBase } from '../port/k1-compile/from-base/encounter-creature-source';
import { fromBaseClone } from './from-base-context';
import { readItemField, readItemFieldReference } from './item-field-reader';
import { withEncounterCreatureEnvironment } from './inventory-environment';

import playerColumns from './from-base-player-columns.json';

/** Native SELECT-row projection, before any PC rule window. Saved zero/null
 * columns are absent so later isset/default decisions match the native builder. */
export function constructPlayerSourceFromBase(source: FromBaseRow, value: (row: ItemFieldRow, key: string) => unknown): FromBaseRow {
    const row: FromBaseRow = {};
    for (const key of playerColumns) {
        const field = value(source, key);
        if (field !== null && field !== undefined && field !== '' && field !== 0 && field !== '0') row[key] = field;
    }
    return row;
}

/** Invalid saved documents are elided rather than poisoning the cold compile. */
function appearanceSource(raw: unknown, body: boolean): FromBaseRow | null {
    try { return body ? creatureBodyAppearanceDocument(raw) : creatureAppearanceDocument(raw); }
    catch { return null; }
}

export function constructPlayerEncounterSourceFromBase(source: FromBaseRow, encounter?: ItemFieldRow | null, summons?: readonly FromBaseRow[]): FromBaseRow {
    const ordinary = fromBaseClone(source); delete ordinary.body_appearance; delete ordinary.appearance;
    const row = constructEncounterCreatureSourceFromBase(withEncounterCreatureEnvironment(ordinary, encounter), summons);
    for (const key of ['body_appearance', 'appearance']) {
        const decoded = appearanceSource(key === 'appearance' ? readItemFieldReference(source, key) : readItemField(source, key), key === 'body_appearance');
        if (decoded) row[key] = decoded;
    }
    return row;
}
